// extracted by css-extract-rspack-plugin
export default {"wrapper":"RTOA7vHJ","inner":"Ks3IoND3","tab":"_2bhuVlSn","tabActive":"uVET48Wd"};